import axios from "axios";

const TOKEN_KEY = "igaplus-client-token";
const REFRESH_KEY = "igaplus-client-refresh";
const ROLE_KEY = "igaplus-client-role";
const EMAIL_KEY = "igaplus-client-email";

function loadFromStorage() {
  return {
    token: localStorage.getItem(TOKEN_KEY) || "",
    refreshToken: localStorage.getItem(REFRESH_KEY) || "",
    role: localStorage.getItem(ROLE_KEY) || "",
    email: localStorage.getItem(EMAIL_KEY) || "",
  };
}

function saveToStorage(state) {
  if (state.token) localStorage.setItem(TOKEN_KEY, state.token);
  else localStorage.removeItem(TOKEN_KEY);
  if (state.refreshToken) localStorage.setItem(REFRESH_KEY, state.refreshToken);
  else localStorage.removeItem(REFRESH_KEY);
  if (state.role) localStorage.setItem(ROLE_KEY, state.role);
  else localStorage.removeItem(ROLE_KEY);
  if (state.email) localStorage.setItem(EMAIL_KEY, state.email);
  else localStorage.removeItem(EMAIL_KEY);
}

export default {
  namespaced: true,
  state: () => ({
    ...loadFromStorage(),
  }),
  getters: {
    isAuthenticated: (s) => !!s.token,
    isClinic: (s) => s.role === "Clinic",
    isNurse: (s) => s.role === "Nurse",
    role: (s) => s.role,
    email: (s) => s.email,
    token: (s) => s.token,
  },
  mutations: {
    setAuth(state, payload) {
      state.token = payload?.token || "";
      state.refreshToken = payload?.refreshToken || "";
      state.role = payload?.role || "";
      state.email = payload?.email || "";
      saveToStorage(state);
    },
    clear(state) {
      state.token = "";
      state.refreshToken = "";
      state.role = "";
      state.email = "";
      saveToStorage(state);
    },
  },
  actions: {
    async login({ commit }, { email, password }) {
      const res = await axios.post(`/identity/login`, { email, password });
      const data = res?.data?.data;
      if (!data?.token) return false;
      commit("setAuth", {
        token: data.token,
        refreshToken: data.refreshToken,
        role: data.role,
        email,
      });
      return data.role || true;
    },
    async registerClinic({ commit }, payload) {
      const res = await axios.post(`/identity/register/clinic`, payload);
      const data = res?.data?.data;
      if (!data?.token) return false;
      commit("setAuth", {
        token: data.token,
        refreshToken: data.refreshToken,
        role: data.role || "Clinic",
        email: payload.email,
      });
      return data.role || "Clinic";
    },
    async registerNurse({ commit }, payload) {
      const res = await axios.post(`/identity/register/nurse`, payload);
      const data = res?.data?.data;
      if (!data?.token) return false;
      commit("setAuth", {
        token: data.token,
        refreshToken: data.refreshToken,
        role: data.role || "Nurse",
        email: payload.email,
      });
      return data.role || "Nurse";
    },
    logout({ commit }) {
      commit("clear");
    },
  },
};
